// import { forEach, hasOneOf, objEqual } from '@/libs/tools';

/**
 * @description 处理嵌套层级
 */
export const forEach = (array, function_) => {
  if (array.length === 0 || !function_) return;
  let index = -1;
  let length_ = array.length;
  while (++index < length_) {
    let item = array[index];
    function_(item, index, array);
  }
};

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetArray, array) => {
  // TODO: 与后端具体权限值，进行加工修改
  return targetArray.some((_) => array.includes(_));
};

// 判定路由是否存有子级
export const hasChild = (item) => {
  return item.children && item.children.length > 0;
};

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback
 */
export const doCustomTimes = (times, callback) => {
  let index = -1;
  while (++index < times) {
    callback(index);
  }
};

export const showThisMenuEle = (item, access) => {
  if (item.meta && item.meta.access && item.meta.access.length > 0) {
    // TODO: 与后端具体权限值，进行加工修改；现有路由角色列表与当前用户角色列表进行配对
    return hasOneOf(item.meta.access, access) ? true : false;
  } else return true;
};

/**
 * @param {Object} obj1
 * @param {Object} obj2
 * @description 判断两个对象是否相等,这两个对象的值只能是数字或字符串 (浅比较)
 */
export const objectEqual = (object1, object2) => {
  const keysArray1 = Object.keys(object1);
  const keysArray2 = Object.keys(object2);

  if (keysArray1.length !== keysArray2.length) return false;
  return keysArray1.length === 0 && keysArray2.length === 0
    ? true
    : keysArray1.some((key) => object1[key] != object2[key]);
};

/**
 * @param {*} route1 路由对象
 * @param {*} route2
 * @description 判断两个路由对象是否相等
 */
export const routeEqual = (route1, route2) => {
  const parameters1 = route1.params || {};
  const parameters2 = route2.params || {};
  const query1 = route1.query || {};
  const query2 = route2.query || {};
  return (
    route1.name === route2.name &&
    objectEqual(parameters1, parameters2) &&
    objectEqual(query1, query2)
  );
};

/**
 * 路由处理统一出口
 * @param {Array} list 通过路由列表得到菜单列表
 * @return {Array}
 */
export const getMenuByRouter = (list, access) => {
  let result = [];
  forEach(list, (item) => {
    if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
      let object = {
        icon: (item.meta && item.meta.icon) || '',
        name: item.name,
        meta: item.meta,
      };
      // 路由关卡，子级、是否有权
      if (
        (hasChild(item) || (item.meta && item.meta.showAlways)) &&
        showThisMenuEle(item, access)
      ) {
        object.children = getMenuByRouter(item.children, access);
      }
      // 直接链接跳转
      if (item.meta && item.meta.href) object.href = item.meta.href;
      if (showThisMenuEle(item, access)) result.push(object);
    }
  });
  return result;
};

/**
 * @param {Array} routes 路由列表
 * @description 路由列表中寻找到 name 为 home 的对象
 */
export const getHomeRoute = (routers) => {
  let index = -1;
  let length_ = routers.length;
  let homeRoute = {};
  while (++index < length_) {
    let item = routers[index];
    if (item.children && item.children.length > 0) {
      let result = getHomeRoute(item.children);
      if (result.name) return result;
    } else {
      if (item.name === 'home') homeRoute = item;
    }
  }
  return homeRoute;
};

/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
export const routeHasExist = (tagNavList, routeItem) => {
  let length = tagNavList.length;
  let result = false;
  // 已存在在 tag list 里一一与当前路由对象进行比较
  doCustomTimes(length, (index) => {
    if (routeEqual(tagNavList[index], routeItem)) result = true;
  });
  return result;
};

/**
 * @param {Array} list 标签列表
 * @param {String} route 当前关闭的标签的 route
 */
export const getNextRoute = (list, route) => {
  let result = {};
  // 恒大于 1，两种情况
  if (list.length === 2) {
    result = getHomeRoute(list);
  } else {
    const index = list.findIndex((item) => routeEqual(item, route));
    index === list.length - 1
      ? (result = list[list.length - 2])
      : (result = list[index + 1]);
  }
  return result;
};

/**
 * @param {Array} routeMatched 当前路由 matched
 * @returns {Array}
 */
export const getHeaderBreadCrumbList = (routeMatched, homeRoute) => {
  let result = routeMatched
    .filter((item) => {
      return item.meta === undefined || !item.meta.hideInBreadCrumb;
    })
    .map((item) => {
      let object = {
        icon: (item.meta && item.meta.icon) || '',
        name: item.name,
        meta: item.meta,
      };
      return object;
    });
  return [Object.assign(homeRoute, { to: homeRoute.path }), ...result];
};

/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由元信息对象
 * @description newRoute 存在则不添加
 */
export const getNewTagList = (list, newRoute) => {
  const { name, path, meta, title } = newRoute;
  let newList = [...list];
  if (newList.findIndex((item) => item.name === name) < 0) {
    newList.push({ name, path, meta, title });
  }
  return newList;
};

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */
// const hasAccess = (access, route) => {
//   if (route.meta && route.meta.access) return hasOneOf(access, route.meta.access)
//   else return true
// }
/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
// export const canTurnTo = (name, access, routes) => {
//   const routePermissionJudge = (list) => {
//     return list.some(item => {
//       if (item.children && item.children.length) {
//         return routePermissionJudge(item.children)
//       } else if (item.name === name) {
//         return hasAccess(access, item)
//       }
//     })
//   }

//   return routePermissionJudge(routes)
// }

export const findNodeUpperByClasses = (ele, classes) => {
  let parentNode = ele.parentNode;
  if (parentNode) {
    let classList = parentNode.classList;
    return classList &&
      classes.every((className) => classList.contains(className))
      ? parentNode
      : findNodeUpperByClasses(parentNode, classes);
  }
};
